import React from "react"


function Modal({ open, handleClose, children }) {
    return (

        <div>
            {open && <div className="loginModal">
                {open && <div onClick={() => handleClose()} className="closeBtn"><i class="fa-solid fa-xmark"></i></div>}
                {open && <div className="loginCont">
                    {children}
                </div>
                }
            </div>}


            {open && <div
                onClick={() => handleClose()}
                className="backdrop"></div>}

        </div>


    )
}

export default Modal
